import React from 'react';
import AiWardenPdfPanel from '../Dataroom2.0/AiWardenPdfPanel';
import IrlCitationSidebar from '../Dataroom2.0/IrlCitationSidebar';
import ObservationCitationSidebar from '../Dataroom2.0/ObservationCitationSidebar';
import aiWardenStyles from '../Dataroom2.0/css/index.module.css';
import styles from './lensIntelligence.module.css';

const LensIntelligenceCitationSidePanel = ({ panelProps }) => {
    const {
        citationPanel,
        irlCitationPanel,
        observationCitationPanel,
        setCitationPanel,
        setIrlCitationPanel,
        setObservationCitationPanel,
        panelExpanded,
        togglePanelExpand,
    } = panelProps || {};

    if (!citationPanel && !irlCitationPanel && !observationCitationPanel) {
        return null;
    }

    return (
        <aside className={`${styles.sidePanelColumn} ${aiWardenStyles.aiWardenPdfColumn}`}>
            {citationPanel ? (
                <AiWardenPdfPanel
                    key={citationPanel.token}
                    file={citationPanel.doc}
                    highlightText={citationPanel.highlightText}
                    pageOneBased={citationPanel.pageOneBased}
                    expanded={panelExpanded}
                    onToggleExpand={togglePanelExpand}
                    onClose={() => setCitationPanel(null)}
                />
            ) : irlCitationPanel ? (
                <IrlCitationSidebar
                    key={irlCitationPanel.token}
                    detail={irlCitationPanel.detail}
                    onClose={() => setIrlCitationPanel(null)}
                />
            ) : observationCitationPanel ? (
                <ObservationCitationSidebar
                    key={observationCitationPanel.token}
                    detail={observationCitationPanel.detail}
                    onClose={() => setObservationCitationPanel(null)}
                />
            ) : null}
        </aside>
    );
};

export default LensIntelligenceCitationSidePanel;
